var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      class: { "content-input": _vm.enableClassBase },
      attrs: { id: _vm.identity }
    },
    [
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.text,
            expression: "text"
          }
        ],
        staticClass: "input-txt",
        class: _vm.inputClass,
        attrs: {
          type: "text",
          required: _vm.isRequired,
          placeholder: _vm.placeholder
        },
        domProps: { value: _vm.text },
        on: {
          keydown: function($event) {
            _vm.writedown($event)
          },
          keyup: function($event) {
            _vm.writeup($event)
          },
          focus: function($event) {
            _vm.onFocus()
          },
          input: function($event) {
            if ($event.target.composing) {
              return
            }
            _vm.text = $event.target.value
          }
        }
      }),
      _vm._v(" "),
      _c(
        "ul",
        {
          staticClass: "ui-autocomplete",
          class: { active: _vm.text != "" && _vm.is_show }
        },
        [
          _vm.text != "" && _vm.is_show
            ? _c(
                "div",
                { staticClass: "show-result" },
                _vm._l(_vm.onSiteContacts, function(dato, idx) {
                  return _c(
                    "li",
                    { key: idx, staticClass: "ui-menu-item item-found" },
                    [
                      _c(
                        "a",
                        {
                          staticClass: "ui-item-result person",
                          attrs: { tabindex: "-1" },
                          on: {
                            click: function($event) {
                              _vm.onSelectItem(dato)
                            }
                          }
                        },
                        [
                          _c("div", { staticClass: "info-container" }, [
                            _c(
                              "div",
                              { staticStyle: { "max-width": "150px" } },
                              [
                                _c("span", { staticClass: "name" }, [
                                  _vm._v(_vm._s(dato.contactName))
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "info-group" }, [
                                  dato.contactPhone != undefined
                                    ? _c("span", { staticClass: "phone" }, [
                                        dato.contactPhone
                                          ? _c("span", [
                                              _vm._v(_vm._s(dato.contactPhone))
                                            ])
                                          : _c("span", [_vm._v("N/A")])
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  dato.contactEmail != undefined
                                    ? _c("span", { staticClass: "email" }, [
                                        _vm._v(_vm._s(dato.contactEmail))
                                      ])
                                    : _c("span", [_vm._v("N/A")])
                                ])
                              ]
                            )
                          ]),
                          _vm._v(" "),
                          _c("div")
                        ]
                      )
                    ]
                  )
                })
              )
            : _vm._e()
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-4a5bbf14", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4a5bbf14","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/events/OnSiteContactSearch.vue
// module id = 1985
// module chunks = 1